/* eslint-disable no-restricted-syntax */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { Editor } from '@ckeditor/ckeditor5-core/src/editor';
import {
  InsertCommentCommand,
  ActiveCommentCommand,
  RemoveCommentCommand,
} from 'vendor/ckeditor/plugins/comment';
import {
  InsertTaskCommand,
  ActiveTaskCommand,
  RemoveTaskCommand,
} from 'vendor/ckeditor/plugins/task';
import { stopEvents, FreezeDocumentFeature } from './helpers';
import { UnFreezeDocumentCommand } from './un-freeze-document-command';

export class FreezeDocumentCommand extends Command {
  editor: Editor;

  isEnabled: boolean;

  constructor(editor: Editor) {
    super(editor);
    this.editor = editor;
    this.isEnabled = false;
  }

  async execute(): Promise<void> {
    // These commands should stay enabled.
    const commentsCommands = [
      InsertCommentCommand,
      ActiveCommentCommand,
      RemoveCommentCommand,
      InsertTaskCommand,
      ActiveTaskCommand,
      RemoveTaskCommand,
    ];

    // Disable commands.
    // Iterate through all the commands added to the editor.
    for (const command of this.editor.commands.commands()) {
      // Do not disable commands from the comments & task plugin.
      // Do not disable commands from the unfreeze plugin.
      if (
        !commentsCommands.includes(command.constructor) &&
        command.constructor !== UnFreezeDocumentCommand
      ) {
        // Force them to be disabled.
        command.forceDisabled(FreezeDocumentFeature);
      }
    }

    const viewDocument = this.editor.editing.view.document;

    // Prevent cutting and pasting. These actions happen during certain events.
    viewDocument.on('cut', stopEvents, { priority: 'highest' });
    viewDocument.on('clipboardInput', stopEvents, {
      priority: 'highest',
    });

    // Prevent doing any changes on Delete key.
    viewDocument.on('delete', stopEvents, { priority: 'highest' });
  }

  refresh(): void {
    this.isEnabled = true;
  }
}
